import React, { useEffect } from "react";

const GameInit = (prop) => {
  var display = ["Ready!", "Rock", "Paper", "Scissor"];

  useEffect(() => {
    const interval = setInterval(() => {
      // setIndex((index) => (index === 3 ? clearInterval(interval) : index + 1));
      prop.onInc();
    }, 1000);

    return () => clearInterval(interval);
  }, [prop]);

  useEffect(() => {
    // console.log("index", prop.index);
  }, [prop.index]);

  return (
    <div className="display-effect">
      <h1 style={{ height: "39px", color: "#f44336" }}>
        {display[prop.index]}
      </h1>
      <img id="Imgcap" src={prop.imageUrl} alt="" onLoad={prop.onImgLoad} />
    </div>
  );
};

export default GameInit;
